'use client';
import { useCallback } from 'react';
import { IntercomProvider } from 'react-use-intercom';
import { INTERCOM_APP_ID } from '@/components/Intercom/data/constants';
import { useIntercomStore } from '@/components/Intercom/data/useIntercomStore';

export const EnvironmentSensitiveWrapperClient = ({ children }: React.PropsWithChildren) => {
  const { onUnreadCountChange, triggerRef, isIntercomEnabled } = useIntercomStore((state) => ({
    onUnreadCountChange: state.onUnreadCountChange,
    triggerRef: state.triggerRef,
    isIntercomEnabled: state.isEnabled,
  }));

  const handleHide = useCallback(() => {
    if (!triggerRef?.current) return;
    triggerRef.current.focus();
  }, [triggerRef?.current]);

  if (isIntercomEnabled) {
    return (
      <IntercomProvider appId={INTERCOM_APP_ID} onUnreadCountChange={onUnreadCountChange} onHide={handleHide}>
        {children}
      </IntercomProvider>
    );
  }

  return children;
};
